export const histogramChartDefault = {
    options: {
        responsive: true,
        legend: {
            display: false
        },
        tooltips: {
            enabled: true,
            displayColors: false
        },
        scales: {
            xAxes: [{
                scaleLabel: {
                    display: true,
                }
            }],
            yAxes: [{
                scaleLabel: {
                    display: true,
                }
            }]
        },
        datasets: {
            bar: {
                barPercentage: 1.2
            }
        }
    }
}

export default histogramChartDefault;